import React from 'react'
import JustRow from "../../styleHelper/JustRow"
import Col from 'react-bootstrap/Col';
import PriceCard from './sections/PriceCard';
import FreeRow from "./sections/FreeRow"
import FetureRow from "./sections/FetureRow"
import MakePackage  from "./sections/MakePackage"
import Fade from 'react-reveal/Fade';
import Header from "../../sections/Header/Header"
import Footer from "../../sections/Footer"

export default function Price(props){
    const pricePack = [
        {
          "offer":false,
          "title":"کلاس آنلاین",
          "time":"یک ماهه",
          "price":"۱,۰۰۰,۰۰۰",
          "list":[
                "تعداد 10 نفر شرکت کننده",
                "اشتراک 3 ویدئو همزمان برای هر کلاس",
                "اشتراک دسکتاپ، اسلاید و انواع فایل"
            ]
        },
        {
            "offer":true,
            "title":"کلاس آنلاین",
            "time":"یک ماهه",
            "price":"۱,۰۰۰,۰۰۰",
            "list":[
                  "تعداد 10 نفر شرکت کننده",
                  "اشتراک 3 ویدئو همزمان برای هر کلاس",
                  "اشتراک دسکتاپ، اسلاید و انواع فایل"
              ]
        },
        {
            "offer":false,
            "title":"کلاس آنلاین",
            "time":"یک ماهه",
            "price":"۱,۰۰۰,۰۰۰",
            "list":[
                  "تعداد 10 نفر شرکت کننده",
                  "اشتراک 3 ویدئو همزمان برای هر کلاس",
                  "اشتراک دسکتاپ، اسلاید و انواع فایل"
              ]
        }
    ]
    return(
        <div id="landing">
            <Header/>
        <div className="price page">
            <JustRow className="alignCenter imageBg leaf-gray-light">
                <Col xs={12}>
                    <h1>لیست قیمت ها و تعرفه ها</h1>
                    <div className="description">
                        <p>بر اساس نیاز خود و میزان بزرگی سازمان خود بسته مورد نظر خود را انتخاب کنید یا اینکه دقیقا بگویید چه میخواهید...</p>
                    </div>
                </Col>
                {pricePack ? pricePack.map((pm,index)=>
                        <Col xs={12} sm={4}>
                            <Fade bottom distance="50px">
                                <PriceCard 
                                    offer={pm.offer}
                                    title={pm.title}
                                    time={pm.time}
                                    price={pm.price}
                                    list={pm.list}
                                />
                            </Fade>
                        </Col>
                    ) : null
                }
            </JustRow>
            <MakePackage/>
            <FreeRow/>
            <FetureRow/>
        </div>
    <Footer/>
    </div>)
}